<template>
  <div
    style="padding-right:15px;"
  >
    <h2 style="font-weight:300">{{ $t('dashboard.logs.title')}}</h2>
    <v-progress-linear
      v-if="loading"
      indeterminate
      :color="enterpriseColor"
    />
    <v-btn v-else style="margin-top:10px" :color="enterpriseColor" @click="handleGetData" dark>{{ $t('common.show') }}</v-btn>
    <v-card :elevation="1" style="margin-top:20px;padding-bottom:10px;" v-if="logs && logs.length > 0">
      <div class="table-logs">
        <v-simple-table v-if="logs && logs.length > 0">
          <thead>
            <tr>
              <th class="text-left" style="font-weight:300">{{ $t('dashboard.logs.username') }}</th>
              <th class="text-left" style="font-weight:300">{{ $t('dashboard.logs.action') }}</th>
              <th class="text-left" style="font-weight:300">{{ $t('dashboard.logs.menuname') }}</th>
              <th class="text-left" style="font-weight:300">{{ $t('dashboard.logs.lmd') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in logs" :key="item.ID" style="padding-top:5px !important;">
              <td>{{ item.Username }}</td>
              <td>{{ item.Action }}</td>
              <td>{{ item.MenuName.substring(0, 30).concat(item.MenuName.length > 20 ? '...' : '') }}</td>
              <td>{{ item.LMD }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    <div
      v-if="pageCount >0"
      class="text-center pt-2"
    >
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="8"
        :elevation="0"
        :color="enterpriseColor"
        @input="handleChangePage"
      />
    </div>
    </v-card>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import constants from '@/constants'

  export default {
    props: {
      locale: {
        type: String,
        required: true
      },
      enterpriseID: {
        type: String,
        required: true
      }
    },
    data: () => ({
      loading: false,
      logs: [],
      page: 1,
      itemsPerPage: 5,
      count: 0,
      pageCount: 0

    }),
    computed: {
      ...mapState('app',['enterpriseColor']),
    },
    watch: {
      enterpriseID: {
        handler: function (newValue) {
          this.logs = []
          this.count = 0
          this.pageCount = 0
          this.itemsPerPage = 5
          this.page = 1
          //this.handleGetLogs(newValue)
        },
        deep: true
      },
    },
    mounted () {
      //this.handleGetLogs(this.enterpriseID)
    },
    methods: {  
      handleGetData () {
        this.handleGetLogs(this.enterpriseID)
      },
      getActionName (id) {
        switch (id) {
          case 1:
            return this.$t('dashboard.logs.actions.sort')
          case 2: 
            return this.$t('dashboard.logs.actions.update')
          case 3:
            return this.$t('dashboard.logs.actions.deleted')
        }
      },
      handleGetPageCount () {
        let page = this.count > 0 ? parseInt(this.count / this.itemsPerPage, 10) : 0
        if (this.count > 0 && (this.count % this.itemsPerPage)!== 0) page++
        return page
      },
      handleGetLogs (id) {
        this.loading=true
        api.getAll(`logs/${id}`, true, this.page, 5, '')
          .then(response => {
            console.log(response)
            this.count = response.count
            this.loading = false
            if (response.data && response.data.length > 0) {
              const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
              this.logs = response.data.filter(x => x.Action !== 1).map(item => {
                return ({
                  Username: item.Username,
                  Action: this.getActionName(item.Action),
                  MenuName: utils.getTranslation(JSON.parse(item.MenuName), this.locale),
                  LMD: new Date(item.LMD).toLocaleDateString(this.locale, options)
                })
              })
              this.pageCount = this.handleGetPageCount()
            }
          })
          .catch (error => {
            console.log(error)
            this.loading = false
          })
      },
      handleChangePage () {
        this.handleGetLogs(this.enterpriseID)
      }
    }
  }
</script>
<style>
.table-logs td {
  vertical-align: middle !important;
}
.v-pagination__item {
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    
}
</style>
